var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showModal)?_c('LoopActionModal',{attrs:{"showModal":_vm.showModal,"width":626,"height":526,"borderRadius":'12px',"showCta":false,"hideTitle":true},on:{"toggle-modal":_vm.toggleModal},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"mt-10"},[_c('VerifyEmailUI')],1)]},proxy:true}],null,false,1630207076)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }